import { Col, Row, notification } from 'antd'
import logo from 'assets/images/logo.png'
import { FormButton, FormInput, LoginPage } from 'components'
import { UserRoleEnum } from 'enums'
import { useFormik } from 'formik'
import { IUserToken } from 'hooks'
import React from 'react'
import { useNavigate } from 'react-router'
import { Link, useSearchParams } from 'react-router-dom'
import API from 'utils/api'
import * as Yup from 'yup'

const loginSchema = Yup.object({
  email: Yup.string().email('Invalid email').required('email is required'),
  password: Yup.string().min(5, 'must more than 5 chr').required('password is required'),
})

export type LoginProps = {
  setToken: (s: IUserToken) => void
}

type FormFields = {
  email: string
  password: string
}

const Login = ({ setToken }: LoginProps) => {
  const [errorMessage, setErrorMessage] = React.useState('')
  const [isLoading, setIsLoading] = React.useState(false)
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const handleSubmit = async ({ email: username, password }: FormFields) => {
    setIsLoading(true)

    try {
      const response = await API.post(`/auth/login`, {
        username,
        password,
      })
      const { token, user } = response.data
      const redirectTo = searchParams.get('redirectTo')
      setToken({ token })
      const redirectRoute =
        (redirectTo !== '/' && redirectTo) ||
        (user.role === UserRoleEnum.ADMIN ? '/admin/dashboard' : '/tenant/dashboard')
      navigate(redirectRoute, {
        replace: true,
      })
    } catch (error: unknown) {
      if (typeof error === 'object' && error) {
        notification.error({ message: 'Check your email and password' })
        setErrorMessage('Check your email and password')
      } else {
        notification.error({ message: 'Network error' })
        setErrorMessage('Network error')
      }
    } finally {
      setIsLoading(false)
    }
  }

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: loginSchema,
    onSubmit: handleSubmit,
  })

  return (
    <Row className='w-full min-h-screen bg-white h-screen overflow-x-hidden '>
      <Col
        span={10}
        xs={24}
        sm={24}
        md={24}
        lg={10}
        className=' min-h-screen p-5 flex justify-center align-center'
        style={{ backgroundColor: '#4d3e92' }}
      >
        <LoginPage />
      </Col>
      {/* xs: 8, sm: 16, md: 24, lg: 32 */}
      <Col span={24} xs={24} sm={24} md={24} lg={14}>
        <Row className={'flex-col h-full w-full'} align='middle' justify='center'>
          <Col className='w-3/4 px-5 flex '>
            <img src={logo} alt='' className='w-3/4  px-5 mt-10 mb-5' />
          </Col>

          <Col className=' px-5 bg-white pb-3  w-full justify-center col-form'>
            <form onSubmit={formik.handleSubmit} className=' space-y-6 px-[30px] py-[30px] '>
              <div className='space-y-4 pb-[26px] '>
                <div>
                  <FormInput
                    id='email'
                    label='E-mail address'
                    name='email'
                    placeholder='e.g. user@mail.com'
                    type='text'
                    labelClassName='font-semibold text-sm'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.email}
                  />
                  {formik.errors.email && formik.touched.email ? (
                    <p className='font-semibold text-sm text-red-600 '>{formik.errors.email}</p>
                  ) : null}
                </div>
                <div>
                  <FormInput
                    id='password'
                    label='Password'
                    name='password'
                    placeholder='type password'
                    type='password'
                    labelClassName='font-semibold text-sm'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.password}
                  />
                  {formik.errors.password && formik.touched.password ? (
                    <p className='font-semibold text-sm text-red-600'>{formik.errors.password}</p>
                  ) : null}
                </div>
                <div className='flex justify-between'>
                  <div className='flex items-center'>
                    <FormInput name='input' type='checkbox' className=' ' />
                    <span className='pl-1 font-medium text-sm'>Remember Me</span>
                  </div>
                </div>
                <div>
                  <span className='text-red-500'> {errorMessage}</span>
                </div>
              </div>
              <FormButton disabled={isLoading} type='submit' title='login' />
            </form>
          </Col>
          <span className='mr-20 mb-5'>
            <Link to={{ pathname: '/forgot-password' }} className='text-lg rw-color hover:text-rw-color'>
              Forget Password?
            </Link>
          </span>
        </Row>
      </Col>
    </Row>
  )
}
export default Login
